import { useCallback, useMemo } from "react";
import { useLedgers } from "@api/ledger.api";

export function useSelectedLedger(entityId?: number, ledgerId?: string) {
    const { data: ledgers } = useLedgers(entityId);
    const getLedgerById = useCallback(
        (id: string) => ledgers?.find((ledger) => ledger.id === id),
        [ledgers],
    );
    const selectedLedger = useMemo(
        () => (ledgerId ? getLedgerById(ledgerId) : undefined),
        [getLedgerById, ledgerId],
    );

    return { ledgers, selectedLedger, getLedgerById };
}
